import { createAction, props } from '@ngrx/store';
import { ContributieEmailTemplate } from './contributie-email-template.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records contributie email template'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records contributie email template success', 
    props<{ listData: ContributieEmailTemplate[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records contributie email template failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record contributie email template',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record contributie email template success', 
    props<{ singleData: ContributieEmailTemplate }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record contributie email template failure', 
    props<{ error: string }>()
);


// Update Data
export const updateRecord = createAction(
    '[Data] Update record contributie email template',
    props<{ id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record contributie email template success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record contributie email template failure',
    props<{ error: string }>()
);


//Reset State
export const resetState = createAction(
    '[Data] reset state contributie email template',
);